import { setActiveCustomerTab, setHeader, setIsLoggedIn, setUserDetails } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';
import { getData } from '@/services/api.service';
import { end_points } from '@/services/endpoints';
import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router';
import { routes, routePrefix } from '@/utils/routes/routes';
import { toast } from 'react-toastify';
import { MdClose, MdDelete, MdPersonAdd, MdSearch } from 'react-icons/md';
import { TbHeart, TbMapPin, TbShoppingCart, TbDotsVertical } from 'react-icons/tb';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { removeCartItem } from '@/core/redux/cartSlice';
import { emptycart, headerLogo } from '@/utils/imagepath';

const Header4 = ({ themeData }: any) => {
  const [editData, setEditData] = useState<any>(themeData);
  const [sticky, setSticky] = useState('');
  const fixedheader = `home-four-header header ${sticky}`;
  const headerData = useSelector((state: RootState) => state.common.header);
  const dispatch = useDispatch();

  const isLoggedIn = useSelector((state: RootState) => state.common.isLoading);
  const [visibleRight, setVisibleRight] = useState(false);
  const cartItems = useSelector((state: RootState) => state.cart.cartItems);
  const formRef = useRef<HTMLFormElement>(null);
  const [value, setValue] = useState<string>('');
  const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | null>(
    null
  );
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const navigate = useNavigate();

  const dataCount = useSelector(
    (state: RootState) => state.common.wishListCount
  );

  const total = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const isSticky = () => {
    const scrollTop = window.scrollY;
    const stickyClass = scrollTop >= 100 ? 'fixed' : '';
    setSticky(stickyClass);
  };

  const getHeader = async () => {
    try {
      const response = await getData(end_points.headers.url);
      dispatch(setHeader(response?.data?.data));
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getHeader();
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', isSticky);
    return () => {
      window.removeEventListener('scroll', isSticky);
    };
  }, []);

  const handleCheckout = () => {
    if (isLoggedIn) {
      if (cartItems?.length == 0) {
        toast.warn('Please add some products to your cart');
      } else {
        setVisibleRight(false);
        navigate(routes.checkout);
      }
    } else {
      toast.warn('Please login to Checkout');
    }
  };

  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setValue(inputValue);

    if (searchTimeout) clearTimeout(searchTimeout);

    const timeout = setTimeout(async () => {
      if (inputValue.trim() !== '') {
        navigate(`${routePrefix}/search/${inputValue}`);
        setIsSearchOpen(false);
      }
    }, 1000);

    setSearchTimeout(timeout);
  };

  var sidebar = document.getElementById("sidebar");
  var overlay = document.getElementById("overlay");

  const sidebarOpen = () => {
    sidebar?.classList.add("active");
    overlay?.classList.add("active");
  };

  const sidebarClose = () => {
    sidebar?.classList.remove("active");
    overlay?.classList.remove("active");
  };

  return (
    <>
      <header className={fixedheader}>
        <div className="header-top">
          <div className="container">
            <div className="row">
              <div className="col-md">
                <div className="header-topnav-list">
                  {/* <ul className="header-topnav-contact">
                    <li>
                      <a href={`tel:${editData?.theme_4?.home?.header?.contact?.contact_number}`} className="">
                        <i className="uil uil-phone me-2" />
                        {editData?.theme_4?.home?.header?.contact?.contact_number}
                      </a>
                    </li>
                    <li>
                      <a href={`mailto:${editData?.theme_4?.home?.header?.contact?.email_id}`} className="">
                        <i className="uil uil-envelope me-2" />
                        {editData?.theme_4?.home?.header?.contact?.email_id}
                      </a>
                    </li>
                  </ul>
                  <ul className="header-topnav-auth">
                    <li className="header-auth header-box menu-hover">
                      <a
                        href="/login"
                        style={{
                          background: 'rgb(4, 106, 56)',
                          color: 'rgb(255, 255, 255)',
                          borderColor: 'rgb(4, 106, 56)',
                        }}
                        className=""
                      >
                        <i className="uil uil-users-alt" />
                        Login / Register
                      </a>
                    </li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div
                className="header-nav position-relative"
                style={{ background: 'rgb(255, 255, 255)' }}
              >
                <div className="row">
                  <div className="col-md-auto col-sm-12">
                    <div className="logo position-relative">
                      <span id="sidebarCollapse" className="d-block d-md-none" onClick={sidebarOpen}>
                        <img
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAUBAMAAACKWYuOAAAAIVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABt0UjBAAAACnRSTlMAn+kJaXHfOan2+lReqgAAAD9JREFUGNNjwAsYlWCgAchjWwUDCUAeeygMFDCQBIxhAMRhEYQBByCPE27DBFQ5VH0kAXYXGCjA8AMHkv9QAQD7KiJgja6M9QAAAABJRU5ErkJggg=="
                          className="img-fluid"
                          alt=""
                        />
                      </span>
                      <a href="/" className="">
                        <img
                          id="site_logo"
                          src={headerData?.logo}
                          alt=""
                        />
                      </a>
                      <span className="mob-user hidden-md dropdown d-block d-md-none">
                        <a
                          className="more-items"
                          data-bs-toggle="dropdown"
                          href="#"
                        />
                        <ul
                          role="menu"
                          className="dropdown-menu"
                          aria-labelledby="drop1"
                        >
                          {!isLoggedIn ? (
                            <li>
                              <Link to={routes.login}>Login</Link>
                            </li>
                          ) : (
                            <>
                              <li>
                                <Link
                                  to={routes.customerDashboard}
                                  onClick={() => {
                                    dispatch(setActiveCustomerTab('account-details'));
                                  }}
                                >
                                  My Account
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to={routes.customerDashboard}
                                  onClick={() => {
                                    dispatch(setActiveCustomerTab('orders'));
                                  }}
                                >
                                  Order History
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to={routes.customerDashboard}
                                  onClick={() => {
                                    dispatch(setActiveCustomerTab('address'));
                                  }}
                                >
                                  Addresses
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to={''}
                                  onClick={() => {
                                    localStorage.clear();
                                    dispatch(setUserDetails({}));
                                    dispatch(setIsLoggedIn(false));
                                    navigate(routes.login);
                                  }}
                                >
                                  Logout
                                </Link>
                              </li>
                            </>
                          )}
                        </ul>
                      </span>
                      {/* Mobile three-dot menu moved out to header container */}
                    </div>
                  </div>
                  <div className="col-md col-sm-12 vcenter">
                    <div className="d-none d-md-flex align-items-center">
                      <ul className="header-link">
                        {headerData.headers.map((header: any) => (
                          <li className="menu-hover" key={header.id}>
                            <Link
                              to={`${header?.slug == '#' ? '#' : routePrefix + '/' + header?.slug}`}
                            >
                              {header?.title}
                            </Link>
                          </li>
                        ))}
                        {headerData?.table_management_enabled === '1' && (
                          <li>
                            <Link to={routes.tableBooking}>Request a Table</Link>
                          </li>
                        )}
                        <li>
                          <Link to={routes.pricing}>Pricing</Link>
                        </li>
                      </ul>
                      <ul className="header-link-right">
                        {!isLoggedIn ? (
                          <li>
                            <Link to={routes.login}>Login</Link>
                          </li>
                        ) : (
                          <li className="user-menu position-relative">
                            <MdPersonAdd size={22} />
                            <ul className="user-dropdown-menu">
                              <li>
                                <Link
                                  to={routes.customerDashboard}
                                  onClick={() => {
                                    dispatch(setActiveCustomerTab('account-details'));
                                  }}
                                >
                                  My Account
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to={routes.customerDashboard}
                                  onClick={() => {
                                    dispatch(setActiveCustomerTab('orders'));
                                  }}
                                >
                                  Order History
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to={routes.customerDashboard}
                                  onClick={() => {
                                    dispatch(setActiveCustomerTab('address'));
                                  }}
                                >
                                  Addresses
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to={''}
                                  onClick={() => {
                                    localStorage.clear();
                                    dispatch(setUserDetails({}));
                                    dispatch(setIsLoggedIn(false));
                                    navigate(routes.login);
                                  }}
                                >
                                  Logout
                                </Link>
                              </li>
                            </ul>
                          </li>
                        )}
                        <li>
                          <button
                            className="border-0 bg-transparent p-0"
                            onClick={() => setIsSearchOpen(!isSearchOpen)}
                            title="Search"
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <MdSearch size={22} />
                          </button>
                        </li>
                        <li>
                          <Link
                            to={isLoggedIn ? routes.trackOrder : routes.login}
                            onClick={() =>
                              !isLoggedIn && toast.warning('Please Login to Tract Order')
                            }
                            title="Track Order"
                          >
                            <TbMapPin size={22} />
                          </Link>
                        </li>
                        <li className="cart__menu position-relative">
                          <Link
                            to={isLoggedIn ? routes.customerDashboard : routes.login}
                            onClick={() => {
                              if (isLoggedIn) {
                                dispatch(setActiveCustomerTab('wishlist'));
                              } else {
                                toast.warning('Please Login to Wishlist');
                                navigate(routes.login);
                              }
                            }}
                            title="Wishlist"
                          >
                            <TbHeart size={22} />
                          </Link>

                          <span className="badge badge-light cart_qty position-absolute start-100 translate-middle">
                            {isLoggedIn ? dataCount : 0}
                          </span>
                        </li>
                        <li className="cart__menu position-relative">
                          <button
                            className="border-0 bg-transparent"
                            onClick={() => {
                              setVisibleRight(true);
                            }}
                          >
                            {/* <button type='button'></button> */}
                            <TbShoppingCart size={22} title="Cart" />
                            <span className="badge badge-light cart_qty position-absolute start-100 translate-middle">
                              {cartItems?.length}
                            </span>
                          </button>
                        </li>
                      </ul>
                      <Sidebar
                        visible={visibleRight}
                        position="right"
                        onHide={() => setVisibleRight(false)}
                        showCloseIcon={false}
                        className="custom-sidebar"
                      >
                        {/* Header */}
                        <div className="cart-header">
                          <div className="cart-title">My Cart</div>
                          <Button
                            icon={<MdClose size={20} />}
                            className="p-button-text p-button-rounded p-button-danger cart-close-btn"
                            onClick={() => setVisibleRight(false)}
                          />
                        </div>

                        {/* Content */}
                        {cartItems?.length > 0 ? (
                          <div className="cart-content">
                            {cartItems.map((item, index) => (
                              <div key={index} className="cart-item">
                                <div className="cart-item-details">
                                  <div className="cart-description">
                                    <div className="cart-image">
                                      <img
                                        src={item?.image}
                                        alt={item?.name}
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="cart-info-details">
                                      <div className="cart-title">
                                        <p>{item?.name}</p>
                                      </div>
                                      <div className="quantity">
                                        <p>
                                          <span className="text-muted">
                                            {(item as any)?.variant && `(${(item as any)?.variant}) `}
                                          </span>
                                          {item?.quantity} x {item?.price}
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="cart-remove">
                                    <button
                                      onClick={() => dispatch(removeCartItem(item?.id))}
                                    >
                                      <MdDelete size={20} color="red" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="empty-cart-content">
                            <img
                              src={emptycart}
                              alt="Empty Cart"
                              className="empty-cart-image"
                            />
                            <p className="empty-cart-text">
                              Your cart is currently empty
                            </p>
                            <Link to={routes?.home} className="shop-now-btn">
                              Shop Now
                            </Link>
                          </div>
                        )}

                        {/* Footer */}
                        <div className="cart-footer">
                          <span>Subtotal:</span>
                          <span className="subtotal-amount">{total.toFixed(2)}</span>
                        </div>
                        <div className="cart-footer-btns d-flex ">
                          <Link
                            to={routes.cart}
                            className="btn btn-primary w-100 m-2"
                            onClick={() => setVisibleRight(false)}
                          >
                            View Cart
                          </Link>
                          <button
                            className="btn btn-secondary w-100 m-2"
                            onClick={handleCheckout}
                          >
                            Checkout
                          </button>
                        </div>
                      </Sidebar>
                    </div>
                  </div>
                </div>
                {/* Search Bar Dropdown - Same as Header 6 */}
                {isSearchOpen && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    width: '100%',
                    background: '#fff',
                    padding: '40px 0',
                    boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
                    zIndex: 99,
                    borderTop: '1px solid #f0f0f0',
                    animation: 'slideDown 0.3s ease-out'
                  }}>
                    <div className="container position-relative">
                      <form
                        ref={formRef}
                        className="header-search"
                        style={{ maxWidth: '700px', margin: '0 auto' }}
                        onSubmit={(e) => {
                          e.preventDefault();
                          if (value.trim() !== '') {
                            navigate(`${routePrefix}/search/${value}`);
                            setIsSearchOpen(false);
                          }
                        }}
                      >
                        <div className="input-group" style={{ height: '55px', display: 'flex', flexWrap: 'nowrap' }}>
                          <input
                            id="search"
                            type="text"
                            placeholder="Search for products..."
                            name="search"
                            className="form-control"
                            value={value}
                            onChange={handleSearch}
                            autoFocus
                            style={{
                              borderRadius: '30px 0 0 30px',
                              border: '2px solid #000',
                              borderRight: 'none',
                              paddingLeft: '25px',
                              fontSize: '16px',
                              boxShadow: 'none',
                              height: '100%',
                              margin: 0
                            }}
                          />
                          <button
                            className="btn"
                            type="button"
                            onClick={() => setIsSearchOpen(false)}
                            style={{
                              backgroundColor: '#000',
                              color: '#fff',
                              borderRadius: '0 30px 30px 0',
                              padding: '0 30px',
                              border: '2px solid #000',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              height: '100%',
                              margin: 0,
                              cursor: 'pointer'
                            }}
                          >
                            <MdClose size={24} />
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                )}
                {/* Absolute three-dot menu in header container (mobile only) */}
                <div className="position-absolute end-0 top-50 translate-middle-y d-block d-md-none" style={{ zIndex: 1020 }}>
                  <span className="dropdown">
                    <button
                      className="border-0 bg-transparent p-0"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      aria-label="More options"
                    >
                      <TbDotsVertical size={22} />
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <button
                          className="dropdown-item d-flex align-items-center gap-2"
                          onClick={() => setIsSearchOpen(!isSearchOpen)}
                        >
                          <MdSearch size={20} />
                          <span>Search</span>
                        </button>
                      </li>
                      <li><hr className="dropdown-divider" /></li>
                      {!isLoggedIn ? (
                        <li>
                          <Link className="dropdown-item" to={routes.login}>Login</Link>
                        </li>
                      ) : (
                        <>
                          <li>
                            <Link
                              className="dropdown-item"
                              to={routes.customerDashboard}
                              onClick={() => {
                                dispatch(setActiveCustomerTab('account-details'));
                              }}
                            >
                              My Account
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item"
                              to={routes.customerDashboard}
                              onClick={() => {
                                dispatch(setActiveCustomerTab('orders'));
                              }}
                            >
                              Order History
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item"
                              to={routes.customerDashboard}
                              onClick={() => {
                                dispatch(setActiveCustomerTab('address'));
                              }}
                            >
                              Addresses
                            </Link>
                          </li>
                        </>
                      )}
                      <li><hr className="dropdown-divider" /></li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to={isLoggedIn ? routes.trackOrder : routes.login}
                          onClick={() => !isLoggedIn && toast.warning('Please Login to Tract Order')}
                        >
                          Track Order
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item d-flex align-items-center justify-content-between"
                          to={isLoggedIn ? routes.customerDashboard : routes.login}
                          onClick={() => {
                            if (isLoggedIn) {
                              dispatch(setActiveCustomerTab('wishlist'));
                            } else {
                              toast.warning('Please Login to Wishlist');
                              navigate(routes.login);
                            }
                          }}
                        >
                          <span>Wishlist</span>
                          <span className="badge bg-secondary">{isLoggedIn ? dataCount : 0}</span>
                        </Link>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => setVisibleRight(true)}
                        >
                          View Cart ({cartItems?.length})
                        </button>
                      </li>
                      {isLoggedIn && (
                        <>
                          <li><hr className="dropdown-divider" /></li>
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={() => {
                                localStorage.clear();
                                dispatch(setUserDetails({}));
                                dispatch(setIsLoggedIn(false));
                                navigate(routes.login);
                              }}
                            >
                              Logout
                            </button>
                          </li>
                        </>
                      )}
                    </ul>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <style>
        {`
          @keyframes slideDown {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .header-search .form-control:focus {
            border-color: #000;
          }
        `}
      </style>
      <nav
        id="sidebar"
        className="mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar"
        style={{ overflow: "visible" }}
      >
        <div
          id="mCSB_1"
          className="mCustomScrollBox mCS-minimal mCSB_vertical mCSB_outside"
          style={{ maxHeight: "480px" }}
        >
          <div
            id="mCSB_1_container"
            className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
            style={{ position: "relative", top: "0px", left: "0px" }}
            dir="ltr"
          >
            <div id="dismiss" onClick={sidebarClose}>
              <i className="fa fa-arrow-left"></i>
            </div>
            <div className="sidebar-header"></div>
            <ul className="list-unstyled components">
              {headerData.headers.map((header: any) => (
                <li key={header.id}>
                  <Link
                    to={`${header?.slug == '#' ? '#' : routePrefix + '/' + header?.slug}`}
                  >
                    {header?.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div
          id="mCSB_1_scrollbar_vertical"
          className="mCSB_scrollTools mCSB_1_scrollbar mCS-minimal mCSB_scrollTools_vertical"
          style={{ display: "none" }}
        >
          <div className="mCSB_draggerContainer">
            <div
              id="mCSB_1_dragger_vertical"
              className="mCSB_dragger"
              style={{
                position: "absolute",
                minHeight: "0px",
                height: "0px",
                top: "0px",
                display: "block",
              }}
            >
              <div
                className="mCSB_dragger_bar"
                style={{ lineHeight: "0px" }}
              ></div>
            </div>
            <div className="mCSB_draggerRail"></div>
          </div>
        </div>
      </nav>
      <div id="overlay" onClick={sidebarClose}></div>
    </>
  );
};

export default Header4;
